import Pass from "_src/render_graph/pass";
import resourceManager from "_src/render_graph/resource_manager";

import objFactory from "_src/engine/factories/object";
import FrameBuffer from "_src/engine/framebuffer";
import primitiveFactory from "_src/engine/factories/primitive";
import {primitiveType, blendFactor, pixelBufferType, attachmentId} from "_src/engine/constants";
import Camera from "_src/engine/camera";

import CircleShader from "_src/shaders/circle/circle";
import CopyShader from "_src/shaders/copy/copy";
import BlurShader from "_src/shaders/blur/blur";

const _reduceFactor = 1/4;
export default class MirrorPass extends Pass {

  constructor(attachmentsStorage, camera, blurEnabled = true) {

    super(attachmentsStorage);

    this.blurEnabled = blurEnabled;
    this.init(camera);

  }

  init(camera) {
    if (this.blurEnabled) {
      const screenQuadCamera = new Camera();
      const copyScene = this._addScene(screenQuadCamera);
      const blurHorScene = this._addScene(screenQuadCamera);
      const blurVerScene = this._addScene(screenQuadCamera);

      const screenChunk = primitiveFactory.create(primitiveType.SCREEN_QUAD);

      const copyShader = new CopyShader({transparent: true});
      copyShader.setSourceBlendFactor(blendFactor.ONE);
      const copyPlane = objFactory.createDrawable(copyShader);
      copyPlane.addGeometryChunk(screenChunk);
      copyScene.add(copyPlane);

      const blurHorShader = new BlurShader({
        horDir: true,
        depthTest: false
      });
      const blurHorPlane = objFactory.createDrawable(blurHorShader);
      blurHorPlane.addGeometryChunk(screenChunk);
      blurHorScene.add(blurHorPlane);

      const blurVerShader = new BlurShader({
        horDir: false,
        depthTest: false
      });
      const blurVerPlane = objFactory.createDrawable(blurVerShader);
      blurVerPlane.addGeometryChunk(screenChunk);
      blurVerScene.add(blurVerPlane);
    }

    const drawScene = this._addScene(camera);
    drawScene.clearedColor = false;
    drawScene.clearedDepth = false;
    drawScene.clearedStencil = false;
    let drawShader = new CircleShader({
      useBlur : this.blurEnabled,
    });
    let drawModel = objFactory.createDrawable(drawShader);
    drawModel.setDiffuseColor(1.0, 1.0, 1.0);
    drawModel.setOpacity(0.5);
    drawModel.addGeometryChunk(primitiveFactory.create(primitiveType.PLANE, {width: 1, height: 1}));
    drawScene.add(drawModel);
  }

  update() {
    const drawFB = new FrameBuffer([this.attachmentsStorage[attachmentId.BASE_COLOR_TEXTURE]],
      this.attachmentsStorage[attachmentId.INTERFACE_DEPTH]);

    const drawScene = this.getLastScene();
    drawScene.setFramebuffer(drawFB);
    const drawPlane = drawScene.getChildren()[0];

    if (this.blurEnabled) {

      const copyScene = this.getScenes()[0];
      const blurHorScene = this.getScenes()[1];
      const blurVerScene = this.getScenes()[2];
      const drawScene = this.getScenes()[3];

      const width = drawScene.camera.viewport[2];
      const height = drawScene.camera.viewport[3];

      copyScene.resize(width * _reduceFactor, height * _reduceFactor);

      const tmpTexture1 = resourceManager.initBuffer(pixelBufferType.T_RGBA,
        {width: width * _reduceFactor, height: height * _reduceFactor});
      const tmpTexture2 = resourceManager.initBuffer(pixelBufferType.T_RGBA,
        {width: width * _reduceFactor, height: height * _reduceFactor});

      const copyFB = new FrameBuffer([tmpTexture1], null);
      const blurHorFB = new FrameBuffer([tmpTexture2], null);
      const blurVerFB = copyFB; //don't create because its actually same buffer

      copyScene.setFramebuffer(copyFB);
      blurHorScene.setFramebuffer(blurHorFB);
      blurVerScene.setFramebuffer(blurVerFB);

      const copyPlane = copyScene.getChildren()[0];
      copyPlane.setTexture(drawFB.colorAttachments[0], 0);

      const blurHorPlane = blurHorScene.getChildren()[0];
      blurHorPlane.setTexture(copyFB.colorAttachments[0], 0);

      const blurVerPlane = blurVerScene.getChildren()[0];
      blurVerPlane.setTexture(blurHorFB.colorAttachments[0], 0);

      drawPlane.setTexture(blurVerFB.colorAttachments[0], 0);
    }

  }

  resize(width, height) {
    if (this.blurEnabled) {
      this.getScenes()[0].resize(width * _reduceFactor, height * _reduceFactor);
      this.getScenes()[1].resize(width * _reduceFactor, height * _reduceFactor);
      this.getScenes()[2].resize(width * _reduceFactor, height * _reduceFactor);
    }
    this.getLastScene().resize(width, height);
  }

}
